module.exports = __webpack_public_path__ + "static/media/starKHUT.05e4341d.svg";